import { FC } from 'react'
import { col } from '@utils/styles'
import classNames from 'classnames'
import { getTitleKey } from '@utils/timeCards'
import { Header } from './time-card/Header'
import { Body } from './time-card/Body'
import { Footer } from './time-card/Footer'
import { useTranslation } from 'react-i18next'
import { TimeCardsContextTimeCard } from '@features/time-logging/providers/TimeCardsContextProvider'

interface Props {
  timeCard: TimeCardsContextTimeCard
  className?: string
}

const TimeCard: FC<Props> = ({ timeCard, className }) => {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        col(timeCard.date),
        'flex flex-col select-none overflow-hidden min-h-[121px border-none',
        className,
      )}
      title={t(getTitleKey(timeCard))}
    >
      <Header
        numberLabel={timeCard.numLabel}
        timeCard={timeCard}
        className={classNames('border border-b-0 rounded-t', {
          'bg-neutral-100 border-neutral-300':
            !timeCard.submitted && !timeCard.isValid,
          'bg-success-700 border-success-700 text-white':
            timeCard.isValid && !timeCard.submitted,
          'bg-primary-500 border-primary-500 text-white': timeCard.submitted,
        })}
      />

      <div
        className={classNames(
          'flex flex-col overflow-hidden rounded-b border border-t-0 grow',
          {
            'border-neutral-300': !timeCard.submitted && !timeCard.isValid,
            'bg-neutral-50': timeCard.isInFuture,
            'bg-success-100 border-success-300':
              timeCard.isValid && !timeCard.submitted,
            'bg-primary-100 border-primary-300': timeCard.submitted,
          },
        )}
      >
        <Body
          timeCard={timeCard}
          className={classNames({
            'border-b border-dashed': timeCard.isValid || timeCard.submitted,
            'border-success-300': timeCard.isValid,
            'border-primary-300 text-neutral-900': timeCard.submitted,
          })}
        />
        <Footer
          timeCard={timeCard}
          className={classNames({
            'bg-neutral-100':
              !timeCard.submitted &&
              !timeCard.sentToPayrollAt &&
              (timeCard.isInFuture || !timeCard.isValid),
          })}
        />
      </div>
    </div>
  )
}

export default TimeCard
